<template>
    <div class="row">
        <div>
            <p><b>Data Type</b></p>
            <select v-model="saveObject.dataType" @change="save">
                <option v-for="dataType in dataTypes" :key="dataType.id" :val="dataType.internalName">{{ dataType.displayName }}</option>
            </select>
        </div>
        <div v-if="saveObject.dataType === 'Number'">
            <p><b>Decimals to round to</b></p>
            <p>Enter -1 to disable all rounding</p>
            <input type="number" v-model="saveObject.decimals" @blur="save" />
        </div>
    </div>
    <div class="row">
        <div style="width: 100%;">
            <p><b>Equation</b></p>
            <p>+, -, *, / for basic operations, ( ) to specify operation order, min(val1, val2) and max(val1, val2) will return the appropriate value, abs(val) will return the absolute value</p>
            <input class="equation" type="text" v-model="saveObject.equation" 
                @keyup="triggerAutocomplete('input')"
                @blur="triggerAutocomplete('blur')" 
                @keydown.enter="triggerKeyPress('Enter')" 
                @keydown.down="triggerKeyPress('ArrowDown')" 
                @keydown.up="triggerKeyPress('ArrowUp')"/>
            <AutoComplete :data="attributeList" :value="lastWordInEquation" :onBlur="save" :onValueChanged="autoCompleteChanged"
                placeholder="" internalValueField="displayValue" displayField="displayValue" searchField="searchValue" ref="autocomplete"></AutoComplete>
        </div>
    </div>
</template>

<script>
import AutoComplete from "@/components/shared/AutoComplete.vue";
import { data } from '@/shared/data';

export default {
    name: 'MathOperation',
    components: { AutoComplete },
    props: {
        parentObject: Object,
        attributes: Array,
        onSave: {
            type: Function,
            required: true
        },
        mathConfig: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            // the following comment is necessary because the regex wrongly causes eslint errors
            // eslint-disable-next-line
            equationSplitRegex: /(?=[\s+\-*\/\(\)\^])|(?<=[\s+\-*\/\(\)\^])/g,
            attributeList: [],
            typeList: [],
            saveObject: {
                equation: '',
                decimals: 0,
                dataType: 'Number'
            }
        }
    },
    computed: {
        lastWordInEquation() {
            // filter dropdown only on last word in the string
            // split the string on whitespace and math characters, but don't purge the delimiters
            const wordArray = this.saveObject.equation.split(this.equationSplitRegex);
            return wordArray[wordArray.length - 1];
        },
        dataTypes() {
            return this.typeList.filter(obj => obj.internalName !== 'NotSet');
        }
    },
    async mounted() {
        if(!this.attributes) {
            let attrLst = await data.getAllAttributes('', true);
            this.attributeList = attrLst.map(attr => {
                return {
                    displayValue: attr.code,
                    searchValue: attr.code
                }
            });
        } else 
            this.attributeList = this.attributes;
        
        this.attributeList.sort((a,b) => { 
            if (a.displayValue < b.displayValue) {
                return -1;
            }
            if (a.displayValue > b.displayValue) {
                return 1;
            }
            return 0;
         });

        this.typeList = await data.getEnumList('ComplexMathOperationDataTypes');
        if(this.mathConfig.equation)
            this.saveObject.equation = this.mathConfig.equation;
        if(this.mathConfig.decimals)
            this.saveObject.decimals = this.mathConfig.decimals;
        if(this.mathConfig.dataType)
            this.saveObject.dataType = this.mathConfig.dataType;
    },
    methods: {
        save: async function() {
            await this.onSave(this.parentObject, this.saveObject);
        },
        autoCompleteChanged: function(obj, newValue) {
            let wordArray = this.saveObject.equation.split(this.equationSplitRegex);
            wordArray.splice(wordArray.length - 1, 1, newValue);
            wordArray = wordArray.filter(word => word !== ' ');
            this.saveObject.equation = wordArray.join(' ');
        },
        triggerAutocomplete: function(eventType) {
            this.$refs.autocomplete.$refs.input.dispatchEvent(new Event(eventType));
        },
        triggerKeyPress: function(key) {
            this.$refs.autocomplete.$refs.input.dispatchEvent(new KeyboardEvent('keydown', {key: key}));
        }
    }
}
</script>

<style scoped>
    .row {
        width: 100%;
        display: flex;
        flex-direction: row;
    }
    .row div {
        margin-right: 3em;
        justify-content: space-between;
    }
    .row .equation {
        width: 100%;
    }
    :deep(.autoCompleteContainer) input {
        display: none;
    }
</style>